import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/daf9kt3ep053ijub1lv0";

export default function Contact() {
  const [status, setStatus] = useState<{ type: "idle" | "loading" | "success" | "error"; msg?: string }>({
    type: "idle",
  });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;

    const honey = new FormData(form).get("website_alt") as string;
    if (honey && honey.trim().length > 0) {
      setStatus({ type: "success", msg: "感谢留言，我们会尽快回复你！" });
      return;
    }

    setStatus({ type: "loading" });
    try {
      const body = new FormData(form);
      body.delete("website_alt");
      const res = await fetch(FORM_URL, { method: "POST", body });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta ?? {}) as Record<string, string>;
      const code = parsed?.code as string | undefined;
      const serverMsg =
        meta?.message || (parsed?.message as string | undefined) || meta?.detail || "";
      const lower = serverMsg.toLowerCase();

      if (res.ok && code === "OK" && !lower.includes("spam")) {
        setStatus({ type: "success", msg: "提交成功，感谢你的留言！" });
        form.reset();
      } else {
        setStatus({
          type: "error",
          msg: serverMsg || "提交失败，请稍后再试。",
        });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，请稍后再试。" });
    }
  }

  return (
    <section id="contact" className="w-full bg-background-50 py-14 md:py-20" aria-label="留言交流">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-xl bg-gradient-to-br from-primary-600 to-primary-800 p-6 md:p-12">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div className="text-white">
              <h2 className="font-heading text-2xl font-bold md:text-3xl">
                有想吃的瓜想聊聊？欢迎留言
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-white/85 md:text-base">
                关于吃瓜神器的疑问、你的使用心得、想看的测评方向，
                都可以在下方留言告诉我们。我们会认真阅读每一条反馈，并持续补充实用内容。
              </p>
              <div className="mt-6 flex flex-col gap-2 text-sm text-white/90">
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                  hello@chigua.example.com
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-chat-smile-line" aria-hidden="true"></i>
                  工作日 9:00 - 18:00 在线回复
                </p>
              </div>
            </div>

            <form
              data-readdy-form="gua-contact"
              className="rounded-lg bg-background-50 p-6 ring-1 ring-background-200"
              onSubmit={handleSubmit}
            >
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="name" className="text-xs font-medium text-foreground-700">
                    称呼
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    required
                    placeholder="怎么称呼你"
                    className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:bg-white focus:ring-2 focus:ring-primary-200"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="email" className="text-xs font-medium text-foreground-700">
                    邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="用于回复你"
                    className="w-full rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:bg-white focus:ring-2 focus:ring-primary-200"
                  />
                </div>
              </div>

              <div className="mt-4 flex flex-col gap-1.5">
                <label htmlFor="message" className="text-xs font-medium text-foreground-700">
                  留言内容
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  required
                  maxLength={500}
                  placeholder="想了解吃瓜神器的哪方面？有什么心得想分享？"
                  className="w-full resize-none rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:bg-white focus:ring-2 focus:ring-primary-200"
                ></textarea>
              </div>

              {/* 蜜罐反垃圾字段 */}
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="faux-field"
              />

              <button
                type="submit"
                disabled={status.type === "loading"}
                className="mt-5 w-full whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
              >
                {status.type === "loading" ? "提交中..." : "提交留言"}
              </button>

              {status.type === "success" && (
                <p className="mt-3 rounded-md bg-primary-100 px-3 py-2 text-sm font-medium text-primary-800">
                  <i className="ri-checkbox-circle-line mr-1" aria-hidden="true"></i>
                  {status.msg}
                </p>
              )}
              {status.type === "error" && (
                <p className="mt-3 rounded-md bg-accent-100 px-3 py-2 text-sm font-medium text-accent-800">
                  <i className="ri-error-warning-line mr-1" aria-hidden="true"></i>
                  {status.msg}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}